import React, { useState } from 'react';
import type { UserProfile } from '@types';
import CommunicationTabs, { type CommunicationTab } from './CommunicationTabs';
import FeedbackPanel from './FeedbackPanel';
import OrganizationChatsPanel from './OrganizationChatsPanel';
import SupportQueuePanel from './SupportQueuePanel';

const OrganizationCommunicationPanel: React.FC<{ organizationId: string; organizationRegion: string; currentUser: UserProfile }> = ({ organizationId, organizationRegion, currentUser }) => {
    const [activeTab, setActiveTab] = useState<CommunicationTab>('support');
    return <section className="space-y-6">
        <CommunicationTabs activeTab={activeTab} onChange={setActiveTab} />
        <div hidden={activeTab !== 'support'}><SupportQueuePanel currentUser={currentUser} organizationId={organizationId} enabled={activeTab === 'support'} /></div>
        {activeTab === 'chats' && <OrganizationChatsPanel currentUser={currentUser} organizationId={organizationId} organizationRegion={organizationRegion} />}
        {activeTab === 'feedback' && <FeedbackPanel organizationId={organizationId} />}
    </section>;
};

export default OrganizationCommunicationPanel;
